export default __webpack_public_path__ + "static/media/private_col_ico.9ee114a0.svg";